// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin.toc {
  background: #f9f9f9;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 2rem;
}

.elt-wp-plugin.toc-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.elt-wp-plugin.toc ol {
  padding: 0;
  margin-left: 1.5rem;
}

.elt-wp-plugin.toc li {
  margin-bottom: 0.5rem;
}

.elt-wp-plugin.toc-link {
  color: #0073aa;
  text-decoration: underline;
  cursor: pointer;
}

.elt-wp-plugin.toc-link:hover {
  text-decoration: none;
}

@media (max-width: 768px) {
  .elt-wp-plugin.toc {
    font-size: 0.9rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/TableOfContents.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".elt-wp-plugin.toc {\n  background: #f9f9f9;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  margin-bottom: 2rem;\n}\n\n.elt-wp-plugin.toc-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.elt-wp-plugin.toc ol {\n  padding: 0;\n  margin-left: 1.5rem;\n}\n\n.elt-wp-plugin.toc li {\n  margin-bottom: 0.5rem;\n}\n\n.elt-wp-plugin.toc-link {\n  color: #0073aa;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.elt-wp-plugin.toc-link:hover {\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .elt-wp-plugin.toc {\n    font-size: 0.9rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
